import React from 'react';
import { Box, SelectField } from 'bumbag';
import { Field } from 'formik';
import Loads from 'react-loads';

import sdk from '@medipass/web-sdk';
type Props = {
  isDisabled?: boolean;
  fieldNamePrefix?: string;
};
export default class HealthFundDropdown extends React.Component<Props> {
  static defaultProps = {
    fieldNamePrefix: null,
    isDisabled: false,
  };
  buildFieldName = (name: string) => {
    const { fieldNamePrefix } = this.props;
    return fieldNamePrefix ? `${fieldNamePrefix}.${name}` : name;
  };
  render = () => {
    const { isDisabled } = this.props;
    return (
      <Loads loadOnMount load={() => sdk.healthfunds.getHealthFunds()}>
        {/* @ts-expect-error TS(7031): Binding element 'response' implicitly has an 'any'... Remove this comment to see the full error message */}
        {({ response, isSuccess }) => (
          <Box>
            {isSuccess && (
              <Field
                component={SelectField.Formik}
                disabled={isDisabled}
                name={this.buildFieldName('healthFundId')}
                // @ts-expect-error TS(7006): Parameter 'healthFund' implicitly has an 'any' typ... Remove this comment to see the full error message
                options={response.map(healthFund => ({
                  label: healthFund.displayName,
                  value: healthFund._id,
                }))}
                placeholder="Select a health fund..."
              />
            )}
          </Box>
        )}
      </Loads>
    );
  };
}
